import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock, ArrowLeft, CheckCircle2 } from "lucide-react";
import { PostAxios } from "../../helpers/axiosHelpers";
import { toast } from "sonner"; // Import toast

const ForgotPasswordPage = () => {
  const navigate = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await PostAxios("/auth/forgot-password", { email });

      // Adjust "res.success" based on your actual API response structure
      if (res.success || res.status === 200) {
        setSubmitted(true);
        toast.success(res.msg);
      } else {
        toast.error(res.message || "Failed to send reset instructions.");
      }
    } catch (error) {
      console.error(error);
      toast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center p-6 pt-32">
      <div className="w-full max-w-md bg-white rounded-[2.5rem] p-10 shadow-2xl border border-slate-100 space-y-8">
        {!submitted ? (
          <>
            <div className="text-center space-y-4">
              <div className="w-16 h-16 bg-blue-50 rounded-2xl flex items-center justify-center text-subidha-blue mx-auto">
                <Lock className="w-8 h-8" />
              </div>
              <h2 className="text-3xl font-serif-brand font-black text-slate-900">
                Forgot Password
              </h2>
              <p className="text-slate-500 font-medium">
                No worries, we'll send you reset instructions.
              </p>
            </div>

            <form className="space-y-6" onSubmit={handleSubmit}>
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest px-1">
                  Email address
                </label>
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-5 py-4 bg-slate-50 border border-slate-200 rounded-2xl focus:ring-4 focus:ring-accent-green/20 outline-none transition-all"
                  placeholder="Enter your email"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-subidha-blue hover:bg-slate-900 text-white py-5 rounded-2xl font-black transition-all disabled:opacity-50"
              >
                {loading ? "SENDING..." : "RESET PASSWORD"}
              </button>
              <Link
                to="/login"
                className="w-full flex items-center justify-center space-x-2 text-slate-500 font-bold hover:text-subidha-blue transition-colors"
              >
                <ArrowLeft className="w-4 h-4" />
                <span>Back to login</span>
              </Link>
            </form>
          </>
        ) : (
          <div className="text-center space-y-8 py-4 animate-in fade-in slide-in-from-bottom-4">
            <div className="w-20 h-20 bg-accent-green/10 rounded-full flex items-center justify-center text-accent-green mx-auto">
              <CheckCircle2 className="w-10 h-10" />
            </div>
            <div className="space-y-4">
              <h2 className="text-3xl font-serif-brand font-black text-slate-900">
                Check your email
              </h2>
              <p className="text-slate-500 font-medium leading-relaxed">
                We've sent a password reset link to <br />{" "}
                <b className="text-subidha-blue">{email}</b>
              </p>
            </div>
            <button
              onClick={() => navigate("/login")}
              className="w-full bg-subidha-blue hover:bg-slate-900 text-white py-5 rounded-2xl font-black transition-all"
            >
              BACK TO LOGIN
            </button>
            <p className="text-xs font-bold text-slate-400">
              Didn't receive the email?{" "}
              <button
                type="button"
                onClick={handleSubmit}
                className="text-subidha-blue hover:underline"
              >
                Resend
              </button>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
